<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="用户资产变更单审核" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="this.formData">
                <el-form-item label="审核流向" label-width="120px">
                  <el-select v-model="formData.resultStat" placeholder="" @change="updateFlowDirection">
                    <el-option :value="1" label="通过"></el-option>
                    <el-option :value="2" label="不通过"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注" label-width="120px" >
                  <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                            style="width:10vw!important;" clearable />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="orderFollowUp">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import store from "@/store";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','param', 'dataId', 'wf','billNo' ],
  components: {

  },
  created(){
    this.showInRemark = this.param?this.param.showInRemark?this.param.showInRemark:'':''
    // this.formData.id = this.param?this.param.orderId?this.param.orderId:'':''

    console.log(this.wf)
    this.formData.id = this.dataId
    this.exchangeNo = this.billNo
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
  },
  data() {
    return {
      isdisabledSite: true,
      show3: false,
      showInRemark:"",
      dataId: '',
      nowTime:'',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      isSendApp:false,
      drawer: true,
      formData: {
        resultStat: 1,

        id: null,
        processId: null,
        messageContent:null,
      },
      dispatchStats: [],
      notTrueReasonList:[],
    }
  },
  mounted() {
    this.loadDictData();
  },
  methods: {
    setTimes() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      _this.nowTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      console.log(_this.nowTime,"_this.nowTime");
      this.formData.recallDate = _this.nowTime;
    },

    radioHandleChange(val) {
      if (val == 2) {
        this.isdisabledSite = false
      } else {
        this.isdisabledSite = true
      }
    },

    updateFlowDirection(){
    },

    orderFollowUp() {
      console.log(this.formData.resultStat)
      if (!this.formData.resultStat && this.formData.resultStat !== 0) {
        this.$message.error('审核流向不能为空')
        return false;
      }
      this.$mask.open()
      this.$http({
        url: "/basic/wkAssetTransfer/checkReport",
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$mask.close()
        this.$message.success('确认成功')
        this.$emit('closeD')
        this.$emit('flushed')
        this.$emit('commit', 1)
      }).catch(() => {
        this.$mask.close()
      })
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('commit', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('commit', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
</style>
